import { Network } from '@/utils/network'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getCountryCitites(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response)
  return parsedResponse
}

async function sendRequest(data) {
  const url = `${urls.getCountryCitites}${data.countryCode}`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response?.response?.statusCode == 200
  ) {
    const rawData = response.response.data.result.map(city => ({
      name: city.city,
      latitude: city.lat,
      longitude: city.lng,
      country: city.country,
      countryCode: city.iso2,
      state: city.admin_name,
    }))

    return {
      statusCode: 200,
      data: rawData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getCountryCitites }
